/* ****************************
画像や、ファイルの読み込みによるプログレスバー

2016/12/05 ver 1.2.0    読み込み部分を別ライブラリに分けた
                        onError() を用意した
2016/05/27 ver 1.1.1    違うhostnameのものは弾くようにした
2016/05/24 ver 1.1      onProgress() に urlを追加
                        add_urls() を追加
2016/05/20 ver 1.0  とりあえず作成
*/

/* [javascript] *********************************
var $progress_bar = $('#fadein .fadein__progress');
var CaracolLoadProgress = require('./caracol/util/jquery.load_progress.js');

var progress = new CaracolLoadProgress({
    onProgress: function(total, count, percent) {
        $progress_bar.css({ width: (percent * 100)+'%' });
    },
    onComplete: function(total, count) {
        $progress_bar.css({ width: '100%' });
        setTimeout(function() { $('#fadein').remove(); }, 1700);
    }
});
progress.start();
***********************************/

/* [補足] *********************************
progress.add_urls(array);

自動的に <img src="〜"> <image src="〜"> を読み込み対象とするが、
それ以外に読み込みに追加したいファイルを配列で指定。
***********************************/

import preload from './preload';

export default class CaracolLoadProgress {

    /**
     * コンストラクタ
     * @param {object} config
     */
    constructor(config) {

        const defaults = {
            onProgress(total, count, percent) { },
            onComplete(total, count) { },
            onError(url, jqXHR, textStatus, errorThrown) { },
            urls: []
        };

        this.opt = Object.assign(defaults, config);
        this.urls = this.opt.urls;
        this.total = 0;
    }

    /**
     * URL追加
     * @param {array} list
     */
    add_urls(list) {
        this.urls = this.urls.concat(list);
    }

    /**
     * 読み込み開始
     */
    start() {
        const finished = [];

        // 画像を数える
        _checkImageTags(this);

        // 画像他をプリロード
        preload(this.urls, {
            onProgress: (url, total, count, percent) => {
                this.opt.onProgress(total, count, percent, url);
                finished.push(url);
            }
        })
        .fail((url, jqXHR, textStatus, errorThrown) => {
            this.opt.onError(url, jqXHR, textStatus, errorThrown);
        })
        .done((total, count) => {
            // 全部読み終わった
            this.opt.onComplete(total, count);
        });
    }
}

/**
 * <img> をチェックする
 */
function _checkImageTags(_this) {

    const hostname = /^https?:\/\/[^/]+\//.exec(window.location.href)[0];
    const imgs = document.getElementsByTagName('img');
    const images = document.getElementsByTagName('image');
    let length;

    // <img>
    length = imgs.length;
    if (length) {
        for (let i = 0; i < length; i += 1) {
            // 違うホストのものは弾く
            if (imgs[i].src.indexOf(hostname) === 0) {
                _this.urls.push(imgs[i].src);
            }
        }
    }

    // SVGの<image>
    length = images.length;
    if (length) {
        for (let i = 0; i < length; i += 1) {
            // 違うホストのものは弾く
            if (images[i].src.indexOf(hostname) === 0) {
                _this.urls.push(images[i].src);
            }
        }
    }

    _this.total = _this.urls.length;
}




// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/util/progress.js